import {LatLngExpression} from "leaflet";

export const EcuadorCenter: LatLngExpression = [-0.657396, -83.800946];
export const MapZoom = 6;
export const MapMaxZoom = 18;